export default __webpack_public_path__ + "static/media/Glutathione.6e0990d8.svg";